export default "/bunjo/images/search/map/pin-home-default.svg?70936ff2be1a9810229009708881a9fb";